import React, { useState, useCallback } from 'react';
import Filters from './Filters';
import './EmAberto.scss';
import { Table } from 'semantic-ui-react';
import produce from 'immer';
import history from 'services/history';
import { numFormat, cpfCnpj } from '@rededompedro/utils';
import { paramsToSearchURL } from 'utils';

function openInNewTab(url) {
    const win = window.open(url, '_blank');
    win.focus();
}

export default function EmAberto(props) {
    const [data, setData] = useState({
        companyGrouped: [],
        companyDetailed: [],
        customer: [],
    });
    const [currentTab, setCurrentTab] = useState('companyGrouped');
    const [loading, setLoading] = useState({
        companyGrouped: null,
        companyDetailed: null,
        customer: null,
    });
    const [tab,] = useState(null);

    const [currentFilter, setCurrentFilter] = useState(null);

    function renderDataByState(filterType, numberOfColumns = 0, cb) {
        let message;
        if (loading[filterType] === null) {
            message = 'Faça uma pesquisa para continuar.';
        } else if (loading[filterType] === true) {
            message = 'Carregando, por favor aguarde...';
        } else if (loading[filterType] === false && data[filterType].length === 0) {
            message = 'A busca não retornou dados.';
        } else {
            message = null;
        }

        if (message) {
            return (
                <Table.Row>
                    <Table.Cell
                        style={{ padding: 50 }}
                        textAlign="center"
                        colSpan={numberOfColumns}
                    >
                        {message}
                    </Table.Cell>
                </Table.Row>
            );
        }
        return data[filterType].map(cb);
    }

    const detailing = useCallback((contaId) => {
        return () => {
            if (currentFilter) {
                const { companyId, period } = currentFilter;
                openInNewTab(`${process.env.REACT_APP_SYSTEM_URL}/recebiveis/em-aberto/detalhamento?${paramsToSearchURL({ company_id: companyId, period, conta_id: contaId })}`);
            }
        }
    }, [currentFilter]);

    function renderTable(tab) {
        switch (tab) {
            case 'companyDetailed':
                return (
                    <Table selectable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Tipo de Pagamento</Table.HeaderCell>
                                <Table.HeaderCell>Valor</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {renderDataByState('companyDetailed', 2, (it, i) => (
                                <Table.Row key={i}>
                                    <Table.Cell>
                                        <button className='button-link' onClick={detailing(it.conta_id)}>{it.nome}</button>
                                    </Table.Cell>
                                    <Table.Cell>R$ {numFormat(it.valor_total)}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                        {data.companyDetailed.length > 0 && (
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="left">
                                        <b>R$ {numFormat(data.companyDetailed.reduce((a, b) => ({ valor_total: a.valor_total + b.valor_total }), { valor_total: 0 }).valor_total)}</b>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        )}
                    </Table>
                );

            case 'companyGrouped':
                return (
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Código</Table.HeaderCell>
                                <Table.HeaderCell>Unidade</Table.HeaderCell>
                                <Table.HeaderCell>Valor</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {renderDataByState('companyGrouped', 3, (it, i) => (
                                <Table.Row key={i}>
                                    <Table.Cell>{it.codigo}</Table.Cell>
                                    <Table.Cell>{it.nome_red}</Table.Cell>
                                    <Table.Cell>R$ {numFormat(it.valor_total)}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                        {data.companyGrouped.length > 0 && (
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="left">
                                        <b>R$ {numFormat(data.companyGrouped.reduce((a, b) => ({ valor_total: a.valor_total + b.valor_total }), { valor_total: 0 }).valor_total)}</b>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        )}
                    </Table>
                );

            case 'customer':
                return (
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Cod.</Table.HeaderCell>
                                <Table.HeaderCell>Nome</Table.HeaderCell>
                                <Table.HeaderCell>CPF / CNPJ</Table.HeaderCell>
                                <Table.HeaderCell>Valor</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {renderDataByState('customer', 4, (it, i) => (
                                <Table.Row key={i}>
                                    <Table.Cell>{it.codigo}</Table.Cell>
                                    <Table.Cell>{it.nome}</Table.Cell>
                                    <Table.Cell>{cpfCnpj(it.cpf_cnpj)}</Table.Cell>
                                    <Table.Cell>R$ {numFormat(it.valor_total)}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                        {data.customer.length > 0 && (
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="left">
                                        <b>R$ {numFormat(data.customer.reduce((a, b) => ({ valor_total: a.valor_total + b.valor_total }), { valor_total: 0 }).valor_total)}</b>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        )}
                    </Table>
                );
            default:
        }
    }

    function clear(filterType) {
        setLoading({ ...loading, [filterType]: null });
        setData(
            produce(data, (draft) => {
                draft[filterType] = [];
            }),
        );
        history.push({ search: null });
    }

    function onData(d, filterType) {
        setData(
            produce(data, (draft) => {
                draft[filterType] = d;
            }),
        );
    }

    function onSearch(filterType, params) {
        setCurrentFilter(params);
        setData(
            produce(data, (draft) => {
                draft[filterType] = [];
            }),
        );
    }

    return (
        <div id="recebiveis-em-aberto">
            <Filters
                onTabChange={setCurrentTab}
                setTab={tab}
                onClear={clear}
                onSearch={onSearch}
                onData={onData}
                onLoading={(filterType, value) => setLoading({ ...loading, [filterType]: value })}
            />
            {renderTable(currentTab)}
        </div>
    );
}
